export default __webpack_public_path__ + "static/media/NTORQ 125 RT FI_4.fe94b6e7.webp";